// extracted by mini-css-extract-plugin
export default {"toggle":"BWDD3t0FlFrGFc2tlKRI","checked":"DmaJMskpn9D9LJfZXhMd","toggleKnob":"E2rR_a5Y1uzwb_yhyAPK","toggleInput":"QQj1UgRaRL22kBAuyZeR","disabled":"zpRfDRBgnDDh2ab9pd2O"};